import { render, staticRenderFns } from "./ConsoleInspector.vue?vue&type=template&id=4a9e6988&"
import script from "./ConsoleInspector.vue?vue&type=script&lang=ts&"
export * from "./ConsoleInspector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports